module.exports = __webpack_public_path__ + "fonts/customFactor@2x.f685370562cacdef3bffced95dd9d136.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/customFactor@2x.png
// module id = 748
// module chunks = 9